var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* 店舗マスター(新規作成画面)  */
import React, { useEffect, useCallback, useState } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowzerBack } from '../../BrowzerBack';
import { store_params_init, store_option_init } from '../../Const';
import { scrollPageTop } from '../../Scroll';
import InputText from '../../molecules/maintenance/InputText';
import InputSelect from '../../molecules/maintenance/InputSelect';
import UpdateHistory from '../../molecules/maintenance/UpdateHistory';
import Label from '../../molecules/maintenance/label';
import { useToggle } from '../../hooks/ToggleHooks';
import { navigationToStoreLint } from './StoreCommon';
import ModalTemplate from '../../molecules/ModalTemplate';
import ModalConfirm from '../../molecules/ModalConfirm';
import LoadingModal from '../../organisms/LoadingModal';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '../../Common';
import { convertUpperCaseAlphaNumericSymbol } from '../../Convert';
var StoreCreate = function () {
    //TODO degawa stateを入力項目に合わせて追加および削除する。
    var _a = useToggle(false), is_loading = _a[0], toggleIsLoading = _a[1];
    var _b = useToggle(false), show_update = _b[0], toggleShowUpdate = _b[1];
    var _c = useToggle(false), show_completed = _c[0], toggleShowCompleted = _c[1];
    // 言語
    var _d = useTranslation(), t = _d.t, i18n = _d.i18n;
    // 各項目のパラメータ
    var _e = useState(store_params_init), store_params = _e[0], setStoreParams = _e[1];
    // 各項目のオプション
    var _f = useState(store_option_init), store_options = _f[0], setStoreOptions = _f[1];
    // Ajaxリクエスト中フラグ
    var _g = useState(false), is_connecting = _g[0], setIsConnecting = _g[1];
    // バリデーションメッセージ
    var _h = useState([]), messages = _h[0], setMessages = _h[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        // 言語変更
        i18n.changeLanguage(getLanguage());
        var getStoreList = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        //ローディング画面表示
                        toggleIsLoading();
                        setIsConnecting(true);
                        return [4 /*yield*/, axios.get("" + location.origin + process.env.MIX_MOCK_URL + "/staff/store/create/init")];
                    case 1:
                        response = _a.sent();
                        setStoreParams(response.data.init);
                        setStoreOptions(response.data.options);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //画面トップに遷移
                        scrollPageTop();
                        //ローディング画面非表示
                        toggleIsLoading();
                        setIsConnecting(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // 初期表示時の画面情報を取得する。
        getStoreList();
    }, []);
    /**
     * 販売店情報新規登録処理
     */
    var add = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    if (is_connecting) {
                        return [2 /*return*/];
                    }
                    toggleIsLoading();
                    toggleShowUpdate();
                    setMessages([]);
                    return [4 /*yield*/, axios.post("" + location.origin + process.env.MIX_MOCK_URL + "/staff/store/create", store_params)];
                case 1:
                    response = _a.sent();
                    toggleShowCompleted();
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    setMessages(error_2.response.data.message);
                    console.error(error_2.message);
                    return [3 /*break*/, 4];
                case 3:
                    toggleIsLoading();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [store_params]);
    /**
     * バリデーションメッセージを取得する
     * @param keys 取得キー
     * @returns バリデーションメッセージ
     */
    var getMessage = function (keys) {
        // バリデーションメッセージ取得
        var msg_list = [];
        keys.map(function (key) {
            messages === null || messages === void 0 ? void 0 : messages.map(function (msg) {
                if (msg.key === key) {
                    msg_list.push(msg.message);
                }
            });
        });
        // 重複を除去した配列を返す
        var msg_list_dupl = msg_list.filter(function (x, i, self) {
            return self.indexOf(x) === i;
        });
        // 配列内のメッセージを結合した値を返却
        return msg_list_dupl.join('\n');
    };
    /**
     * 店舗情報パラメータの更新
     *
     * @param event
     * @return void
     */
    var handleChangeStoreParams = useCallback(function (event) {
        var _a = event.currentTarget, id = _a.id, value = _a.value;
        setStoreParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[id] = value, _a));
        });
    }, [setStoreParams]);
    /**
     * 店舗情報パラメータのフォーカスアウト時
     * 全角英数を半角英数にし、小文字を大文字に変換する
     *
     * @param event
     * @return void
     */
    var handleChangeOnBlur = useCallback(function (event) {
        var _a = event.currentTarget, id = _a.id, value = _a.value;
        var convert_value = convertUpperCaseAlphaNumericSymbol(value);
        setStoreParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[id] = convert_value, _a));
        });
    }, [setStoreParams]);
    return (React.createElement("div", null,
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "my-2" },
                React.createElement("div", { className: "col-md-12 col-sm-10" },
                    React.createElement("div", { className: "detaile-header" },
                        React.createElement("button", { className: "btn btn-main-color btn-main-size", disabled: false, onClick: navigationToStoreLint }, "\u623B\u308B"),
                        React.createElement("button", { className: "btn btn-main-color btn-main-size", disabled: false, onClick: toggleShowUpdate }, "\u66F4\u65B0\u5B9F\u884C")))),
            React.createElement(Label, { title: "" }),
            React.createElement("div", { id: "detail" },
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "detail-container" },
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputSelect, { id: "target_brand", title: "\u5BFE\u8C61\u30D6\u30E9\u30F3\u30C9", class_name: "", value: store_params.target_brand, handleChange: handleChangeStoreParams, options: store_options.target_brand, help_message: "", valid_message: getMessage(['target_brand']), t: t }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "store_code", title: "\u8CA9\u58F2\u5E97\u30B3\u30FC\u30C9", class_name: "detail-form-input-small", value: store_params.store_code, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['store_code']), disabled: false, onBlur: handleChangeOnBlur }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "sales_group", title: "\u55B6\u696D\u30B0\u30EB\u30FC\u30D7", class_name: "detail-form-input-small", value: store_params.sales_group, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['sales_group']), disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "sales_staff", title: "\u62C5\u5F53\u30BB\u30FC\u30EB\u30B9", class_name: "detail-form-input-small", value: store_params.sales_staff, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['sales_staff']), disabled: true }))),
                        React.createElement(Label, { title: "EUC\u9023\u52D5\u60C5\u5831" }),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "store_name", title: "\u5C0F\u58F2\u5E97\u540D\u79F0", class_name: "detail-form-input-large", value: store_params.store_name, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['store_name']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "post_code", title: "\u90F5\u4FBF\u756A\u53F7", class_name: "detail-form-input-large", value: store_params.post_code, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['post_code']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "store_address", title: "\u5C0F\u58F2\u5E97\u4F4F\u6240", class_name: "detail-form-input-large", value: store_params.store_address, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['store_address']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "phone_number", title: "\u96FB\u8A71\u756A\u53F7", class_name: "detail-form-input-large", value: store_params.phone_number, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['phone_number']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "business_category", title: "\u696D\u614B\u533A\u5206", class_name: "detail-form-input-large", value: store_params.business_category, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['business_category']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "individual_store_code", title: "\u500B\u5E97\u30B3\u30FC\u30C9", class_name: "detail-form-input-large", value: store_params.individual_store_code, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['individual_store_code']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "individual_store_name", title: "\u500B\u5E97\u540D\u79F0", class_name: "detail-form-input-large", value: store_params.individual_store_name, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['individual_store_name']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "corporation_code", title: "\u6CD5\u4EBA\u30B3\u30FC\u30C9", class_name: "detail-form-input-large", value: store_params.corporation_code, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['corporation_code']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "corporation_name", title: "\u6CD5\u4EBA\u540D\u79F0", class_name: "detail-form-input-large", value: store_params.corporation_name, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['corporation_name']), disabled: true }))),
                        React.createElement(Label, { title: "\u30D6\u30E9\u30F3\u30C9\u5171\u6709\u60C5\u5831(\u5C4B\u53F7)" }),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "official_name", title: "\u6B63\u5F0F\u540D\u79F0", class_name: "detail-form-input-large", value: store_params.official_name, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['official_name']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "official_post_code", title: "\u6B63\u5F0F\u90F5\u4FBF\u756A\u53F7", class_name: "detail-form-input-large", value: store_params.official_post_code, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['official_post_code']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "official_address", title: "\u6B63\u5F0F\u4F4F\u6240", class_name: "detail-form-input-large", value: store_params.official_address, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['official_address']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "official_phone_number", title: "\u6B63\u5F0F\u96FB\u8A71\u756A\u53F7", class_name: "detail-form-input-large", value: store_params.official_phone_number, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['official_phone_number']), disabled: false }))),
                        React.createElement(UpdateHistory, { history: null, t: t }),
                        React.createElement(Label, { title: "\u30D6\u30E9\u30F3\u30C9\u5225\u60C5\u5831" }),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "shop_factor", title: "\u30B7\u30E7\u30C3\u30D7\u56E0\u5B50(\u73FE\u5728)", class_name: "detail-form-input-smale", value: "", handleChange: function () { }, help_message: "", valid_message: "", disabled: true }),
                                React.createElement("button", { className: "btn btn-main-color btn-main-size", disabled: true, onClick: function () { } }, "\u56E0\u5B50\u8868\u793A"))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "customer_rank", title: "\u5F97\u610F\u5148\u30E9\u30F3\u30AF", class_name: "detail-form-input", value: "", handleChange: function () { }, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "postcard_input_check_word", title: "\u30CF\u30AC\u30AD\u5165\u529B\u30C1\u30A7\u30C3\u30AF\u8868\u793A\u6587\u5B57", class_name: "detail-form-input", value: store_params.postcard_input_check_word, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['postcard_input_check_word']), disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "memo", title: "\u30E1\u30E2", class_name: "detail-form-input", value: store_params.memo, handleChange: handleChangeStoreParams, help_message: "", valid_message: getMessage(['memo']), disabled: false }))),
                        React.createElement(UpdateHistory, { history: null, t: t }))))),
        React.createElement(ModalTemplate, { show: show_update, ClickCallBackNo: toggleShowUpdate, ClickCallBackYes: add, title: '確認', body: '新規追加します。よろしいですか？', t: t }),
        React.createElement(ModalConfirm, { show: show_completed, title: '完了', body: '新規追加が完了しました。', clickCallBackConfirm: navigationToStoreLint }),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('store-create')) {
    render(React.createElement(StoreCreate, null), document.getElementById('store-create'));
}
